import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Key, Users, Activity,
  LogOut, Shield, Download
} from "lucide-react";

const navItems = [
  { path: "/seskab-teddy", icon: <LayoutDashboard size={18} />, label: "Dashboard" },
  { path: "/seskab-teddy/licenses", icon: <Key size={18} />, label: "Licenses" },
  { path: "/seskab-teddy/sessions", icon: <Users size={18} />, label: "Active Sessions" },
  { path: "/seskab-teddy/logs", icon: <Activity size={18} />, label: "Logs" },
  { path: "/seskab-teddy/download", icon: <Download size={18} />, label: "Download" },
];

export default function Sidebar({ onLogout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin_key");
    onLogout();
    navigate("/");
  };

  return (
    <div style={styles.sidebar}>
      {/* Logo */}
      <div style={styles.logo}>
        <Shield size={22} color="#6366f1" />
        <span style={styles.logoText}>PIPO Admin</span>
      </div>

      {/* Nav */}
      <nav style={styles.nav}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/"}
            style={({ isActive }) => ({
              ...styles.navItem,
              ...(isActive ? styles.navItemActive : {}),
            })}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <button onClick={handleLogout} style={styles.logoutBtn}>
        <LogOut size={18} />
        <span>Logout</span>
      </button>
    </div>
  );
}

const styles = {
  sidebar: {
    width: 220,
    minHeight: "100vh",
    background: "rgba(255,255,255,0.03)",
    borderRight: "1px solid rgba(255,255,255,0.08)",
    display: "flex",
    flexDirection: "column",
    padding: "0 0 24px 0",
    position: "fixed",
    top: 0, left: 0, bottom: 0,
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "24px 20px",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    marginBottom: 12,
  },
  logoText: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: 0.5,
  },
  nav: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "0 12px",
    flex: 1,
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    borderRadius: 8,
    color: "#8b9cb5",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
    transition: "all 0.15s",
  },
  navItemActive: {
    background: "rgba(99,102,241,0.15)",
    color: "#a5b4fc",
    borderLeft: "3px solid #6366f1",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    margin: "0 12px",
    padding: "10px 12px",
    background: "rgba(239,68,68,0.1)",
    border: "1px solid rgba(239,68,68,0.2)",
    borderRadius: 8,
    color: "#f87171",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
};
